//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
import { createRefetchContainer } from "react-relay";
// suggestion-body imports
import { IProps, IContainer, IState } from "./SuggestionBodyExpensiveMeeting.d";
import {
  suggestionBodyExpensiveMeetingFragments,
  refetchQuery,
} from "./SuggestionBodyExpensiveMeeting.gql";
import * as s from "./SuggestionBodyExpensiveMeeting.styles";
// other components
import { AvatarRow } from "@components/avatar";
import { InfoTip } from "@components/tool-tip";
import { H3 } from "@ui";
// util
import { getAbsoluteDateTimeForEvent } from "@clockwise/client-commons/src/util/format-time";
import { articleUrls } from "@clockwise/client-commons/src/constants/help-center";
// material-ui
import { AccessTime } from "@material-ui/icons";

//////////////////
// COMPONENT
//////////////////
class SuggestionBodyExpensiveMeetingCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      personList: null,
    };
  }

  public componentDidMount() {
    // load persons for avatars
    this.props.relay.refetch(
      {
        calendarIds: this.props.suggestionPayload.targetEvent.calendarIds,
        orgRelayId: this.props.org.id,
      },
      undefined,
      () => {
        if (this.props.org.personsByCalendarIdsErrorable.__typename === "PersonList") {
          const personList = this.props.org.personsByCalendarIdsErrorable;
          this.setState({ personList });
        }
      },
    );
  }

  public render() {
    const { suggestionPayload, org } = this.props;
    const { targetEvent, focusMinutesCost } = suggestionPayload;
    const { personList } = this.state;

    return (
      <div style={s.container}>
        <H3>{targetEvent.title}</H3>
        <div style={s.eventDateRow}>
          <AccessTime {...s.eventDateIcon} />
          <div style={s.eventDate}>{getAbsoluteDateTimeForEvent(targetEvent)}</div>
        </div>
        <div style={s.description.body}>
          <span style={s.description.cost}>-{focusMinutesCost / 60} hr</span> Focus Time for
          attendees
          <InfoTip
            href={articleUrls.focusTime}
            text={<span>Click to learn more about Focus Time cost</span>}
            iconStyle={s.tooltipIcon}
            tipType={"info"}
          />
        </div>
        <AvatarRow
          org={org}
          personList={personList}
          size={35}
          parentName={"SuggestionBodyExpensiveMeeting"}
          filterRooms={true}
        />
      </div>
    );
  }
}

//////////////////
// RELAY
//////////////////
export const SuggestionBodyExpensiveMeeting = createRefetchContainer<IContainer>(
  SuggestionBodyExpensiveMeetingCmpt,
  suggestionBodyExpensiveMeetingFragments,
  refetchQuery,
);
